// this needs to be properly implemented, but also designed nicely
import { Lock } from 'lucide-react';
import { motion } from 'framer-motion';

export default function AuthModal({ initiateGoogleLogin }: { initiateGoogleLogin: (isLinkAccount?: boolean) => Promise<void> }) {
  return (
    <div className="min-h-screen flex flex-col w-full bg-gray-900 text-white relative overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full mix-blend-normal filter blur-[128px] animate-pulse" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-500/10 rounded-full mix-blend-normal filter blur-[128px] animate-pulse delay-700" />
      </div>

      <div className="relative z-10 min-h-screen flex items-center justify-center p-6">
        <motion.div 
          className="max-w-md w-full"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          {/* Header */}
          <div className="text-center space-y-3 mb-8">
            <motion.div 
              className="flex items-center justify-center gap-2"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              <div className="text-[#00A8FF] font-bold text-2xl tracking-tight" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                468 Agentic
              </div>
            </motion.div>
            <p className="text-white/80 text-sm font-medium">
              Sign in with Google to access 468 Agentic
            </p>
          </div>

          {/* Login Form */}
          <motion.div 
            className="backdrop-blur-2xl bg-white/[0.02] rounded-2xl border border-white/[0.05] shadow-2xl p-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <div className="mb-6 text-center">
              <h2 className="text-xl font-semibold text-white/90">Authentication Required</h2>
            </div>

            <div className="space-y-4">
              <motion.button
                onClick={() => initiateGoogleLogin()}
                whileTap={{ scale: 0.98 }}
                className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-white text-[#0A0A0B] rounded-lg text-sm font-medium shadow-lg shadow-white/10 hover:bg-white/90 transition-colors"
              >
                <svg className="w-4 h-4" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Sign in with Google
              </motion.button>

              {/* Info Notice */}
              <div className="mt-6 p-4 bg-blue-500/10 border border-blue-500/20 rounded-lg">
                <h3 className="text-sm font-medium text-blue-300 mb-2">Gmail Integration</h3>
                <p className="text-xs text-blue-400/80">
                  By signing in with Google, you'll automatically get access to Gmail integration.
                  This allows the AI to help you manage your emails, calendar, drive, and more. Enjoy the new era of work!
                </p>
              </div>
            </div>
          </motion.div>

          {/* Footer */}
          <div className="text-center mt-8">
            <p className="text-sm text-white/40">
              v1.1 - 468 Proprietary Technology
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}